<template>
  <div id="top_content" class="content_area">
    <section>
      <div class="content_head">
        <div class="content_title">CATEGORY</div>
        <div class="content_text">カテゴリから商品を選ぶ</div>
      </div>
      <article class="category_list">
        <div>
          <div class="category" @click="routeCategory('DcCategory', {cid: 1})">
            <img :src="getImage('top/category/category_ww.jpg')" class="category_img" />
            <div class="category_text">吊戸棚</div>
          </div>
        </div>
        <div>
          <div class="category" @click="routeCategory('DcCategory', {cid: 2})">
            <img :src="getImage('top/category/category_cb.jpg')" class="category_img" />
            <div class="category_text">食器棚</div>
          </div>
        </div>
        <div>
          <div class="category" @click="routeCategory('DcCategory', {cid: 3})">
            <img :src="getImage('top/category/category_sc.jpg')" class="category_img" />
            <div class="category_text">玄関収納</div>
          </div>
        </div>
        <!-- <div>
          <div class="category" @click="routeCategory('DcCategory', {cid: 4})">
            <img :src="getImage('top/category/category_cc.png')" class="category_img" />
            <div class="category_text">カウンター</div>
          </div>
        </div> -->
        <div>
          <div class="category" @click="routeCategory('DcCategory', {cid: 5})">
            <img :src="getImage('top/category/category_sh.jpg')" class="category_img" />
            <div class="category_text">棚板</div>
          </div>
        </div>
        <div>
          <div class="category" @click="routeCategory('DcCategory', {cid: 6})">
            <img :src="getImage('top/category/category_uc.jpg')" class="category_img" />
            <div class="category_text">カウンター下収納</div>
          </div>
        </div>
        <div>
          <div class="category" @click="routeCategory('DcCategory', {cid: 7})">
            <img :src="getImage('top/category/category_sb.jpg')" class="category_img" />
            <div class="category_text">サイドボード</div>
          </div>
        </div>
        <div>
          <div class="category" @click="routeCategory('DcCategory', {cid: 8})">
            <img :src="getImage('top/category/category_tv.jpg')" class="category_img" />
            <div class="category_text">テレビボード</div>
          </div>
        </div>
        <div>
          <div class="category" @click="routeCategory('DcCategory', {cid: 9})">
            <img :src="getImage('top/category/category_bs.jpg')" class="category_img" />
            <div class="category_text">本棚</div>
          </div>
        </div>
        <div>
          <div class="category" @click="routeCategory('DcCategory', {cid: 14})">
            <img :src="getImage('top/category/category_cl.jpg')" class="category_img" />
            <div class="category_text">クローゼット収納</div>
          </div>
        </div>
        <div>
          <div class="category" @click="routeCategory('DcCategory', {cid: 15})">
            <img :src="getImage('top/category/category_ns.jpg')" class="category_img" />
            <div class="category_text">隙間収納</div>
          </div>
        </div>
        <!-- <div>
          <div class="category" @click="routeCategory('DcCategory', {cid: 16})">
            <img :src="getImage('top/category/category_ct.jpg')" class="category_img" />
            <div class="category_text">可動間仕切収納</div>
          </div>
        </div>
        <div>
          <div class="category" @click="routeCategory('DcCategory', {cid: 17})">
            <img :src="getImage('top/category/category_us.jpg')" class="category_img" />
            <div class="category_text">洗面台</div>
          </div>
        </div> -->
        <div>
          <div class="category" @click="routeCategory('DcCategory', {cid: 18})">
            <img :src="getImage('top/category/category_sf.webp')" class="category_img" />
            <div class="category_text">シェルフ</div>
          </div>
        </div>
        <div class="dummy">
          <div></div>
        </div>
      </article>
    </section>
    <section>
      <div class="content_head">
        <div class="content_title">SCENE</div>
        <div class="content_text">部屋から商品を選ぶ</div>
      </div>
      <article class="location_list">
        <div>
          <div class="location">
            <div class="location_img">
              <img :src="getImage('top/content/scene-living.png')">
              <div class="location_name">Living Room<br>リビング</div>
            </div>
            <div class="location_item location_sub">
              <div>
                <ul class="location_cat">
                  <li class="cat_item" @click="routeCategory('DcCategory', {cid: 1})"><a>吊戸棚</a></li>
                  <li class="cat_item" @click="routeCategory('DcCategory', {cid: 8})"><a>テレビボード</a></li>
                  <!-- <li class="cat_item" @click="routeCategory('DcCategory', {cid: 4})"><a>カウンター</a></li> -->
                  <li class="cat_item" @click="routeCategory('DcCategory', {cid: 5})"><a>棚板</a></li>
                </ul>
              </div>
              <div>
                <ul class="location_cat_sub">
                  <li class="cat_item cat_sub" @click="routeCategory('DcCategory', {cid: 7})"><a>サイドボード</a></li>
                  <!-- <li class="cat_item cat_sub" @click="routeCategory('DcCategory', {cid: 16})"><a>可動間仕切収納</a></li> -->
                  <li class="cat_item cat_sub" @click="routeCategory('DcCategory', {cid: 18})"><a>シェルフ</a></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div class="location">
            <div class="location_img">
              <img :src="getImage('top/content/scene-dining.png')">
              <div class="location_name">Dining Room<br>ダイニング</div>
            </div>
            <div class="location_item">
              <ul class="location_cat">
                <li class="cat_item" @click="routeCategory('DcCategory', {cid: 6})"><a>カウンター下収納</a></li>
                <li class="cat_item" @click="routeCategory('DcCategory', {cid: 7})"><a>サイドボード</a></li>
                <li class="cat_item"><a><br></a></li>
                <li class="cat_item"><a><br></a></li>
                <li class="cat_item"><a><br></a></li>
                <li class="cat_item"><a><br></a></li>
                <li class="cat_item"><a><br></a></li>
              </ul>
            </div>
          </div>
        </div>
        <div>
          <div class="location">
            <div class="location_img">
              <img :src="getImage('top/content/scene-kitchen.png')">
              <div class="location_name">Kitchen<br>キッチン</div>
            </div>
            <div class="location_item">
              <ul class="location_cat">
                <li class="cat_item" @click="routeCategory('DcCategory', {cid: 2})"><a>食器棚</a></li>
                <li class="cat_item" @click="routeCategory('DcCategory', {cid: 15})"><a>隙間収納</a></li>
                <li class="cat_item"><a><br></a></li>
              </ul>
            </div>
          </div>
        </div>
        <div>
          <div class="location">
            <div class="location_img">
              <img :src="getImage('top/content/scene-washroom.png')">
              <div class="location_name">Washroom / Bath<br>洗面所・バス</div>
            </div>
            <div class="location_item">
              <ul class="location_cat">
                <li class="cat_item" @click="routeCategory('DcCategory', {cid: 1})"><a>吊戸棚</a></li>
                <li class="cat_item" @click="routeCategory('DcCategory', {cid: 15})"><a>隙間収納</a></li>
                <!-- <li class="cat_item" @click="routeCategory('DcCategory', {cid: 17})"><a>洗面台</a></li> -->
              </ul>
            </div>
          </div>
        </div>
        <div>
          <div class="location">
            <div class="location_img">
              <img :src="getImage('top/content/scene-study.png')">
              <div class="location_name">Study / Closet<br>書斎・クローゼット</div>
            </div>
            <div class="location_item">
              <ul class="location_cat">
                <li class="cat_item" @click="routeCategory('DcCategory', {cid: 9})"><a>本棚</a></li>
                <li class="cat_item" @click="routeCategory('DcCategory', {cid: 14})"><a>クローゼット収納</a></li>
                <!-- <li class="cat_item" @click="routeCategory('DcCategory', {cid: 16})"><a>可動間仕切収納</a></li> -->
                <li class="cat_item" @click="routeCategory('DcCategory', {cid: 18})"><a>シェルフ</a></li>
              </ul>
            </div>
          </div>
        </div>
        <div>
          <div class="location">
            <div class="location_img">
              <img :src="getImage('top/content/scene-entrance.png')">
              <div class="location_name">Entrance / Entrance<br>玄関・エントランス</div>
            </div>
            <div class="location_item">
              <ul class="location_cat">
                <li class="cat_item" @click="routeCategory('DcCategory', {cid: 3})"><a>玄関収納</a></li>
                <li class="cat_item"><a><br></a></li>
                <li class="cat_item"><a><br></a></li>
                <li class="cat_item"><a><br></a></li>
              </ul>
            </div>
          </div>
        </div>
      </article>
    </section>
<!-- <section>
      <div class="content_head">
        <div class="content_title">OTHER ITEM</div>
        <div class="content_text">その他のアイテム</div>
      </div>
    </section> -->
  </div>
</template>
<script>
import {mapActions, mapState} from 'vuex'

import * as App from '../../../utils/App'
import {DC_STORAGE_KEY} from '../../../constants/App'

const NEWS_VIEW_SIZE = 4

export default {
  name: 'DcTopContent',
  components: {
  },
  props: {
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapState({
      newsList: state => state.newsList
    }),
    viewNewsList: function () {
      if (!this.newsList) return []
      let list = this.newsList.filter(function (element, index) {
        return (index >= 0 && index < NEWS_VIEW_SIZE)
      })
      return list
    }
  },
  methods: {
    ...mapActions({ getNewsList: 'loadNewsList' }),
    getImage: function (image) {
      return App.getYasumokuResource(image)
    },
    route: function (name, params) {
      this.$router.push({
        name: name,
        query: params
      })
    },
    routeCategory: function (name, params) {
      App.removeLocalStorage(DC_STORAGE_KEY.PRODUCT_SEARCH)
      this.route(name, params)
    }
  },
  mounted: function () {
    this.$store.dispatch('loadNewsList', {reload: true})
  },
  created: function () {
  }
}
</script>
<style src="../../css/dccontent.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/hakotan/components/top/DcTopContent.vue